import type { InteractiveVocabularyFragment } from '../../../lesson-builder.graphql.generated';
import type { ImageCropJsonInput } from '../../../../../gql/schema-types';
import { AIDictionaryYearRange, LanguageCodes } from 'global/constants';
import type { Pluck } from 'lib/gql/pluck';

export const SOURCE_AI = 'OpenAI';
export const SOURCE_WORDS_API = 'WordsAPI';
export const SOURCE_USER_DEFINED = 'UserDefined';

export const VOCABULARY_SETTINGS = 0;
export const VOCABULARY_ASK_AI_FOR_DEFINITION = 1;
export const VOCABULARY_EDIT_DEFINITION = 2;
export const VOCABULARY_SETTINGS_ASK_AI_FOR_NEW_DEFINITION = 3;
export const VOCABULARY_NEW_DEFINITION = 4;

export type DictionaryDefinition = {
  id?: number;
  word: string;
  lexical: string;
  sourceDefinition: string | null;
  source?: string;
  aiDefinitions?: Pluck<
    InteractiveVocabularyFragment,
    'vocabularyDefinitions.aiDefinitions'
  > | null;
};

export type ImageData = {
  key?: string;
  fileName?: string;
  designId?: string;
  cropData?: ImageCropJsonInput;
  original?: string;
  imageUrl?: string;
  alt?: string;
};

export type FormDefinition = {
  id: string;
  year: AIDictionaryYearRange;
  language: LanguageCodes;
  description?: string;
  error?: string;
};

export type FormExample = {
  example: string;
  exampleId: string;
  language: LanguageCodes;
  image?: ImageData;
  error?: string;
  skipGeneratingImage?: boolean;
  isGeneratingImage?: boolean;
};

export type FormWordsTranslation = {
  word: string;
  language: LanguageCodes;
  error?: string;
};
